import { tw } from '@/utils/tw';
import DialogTheme from 'base/components/Dialog/theme';

const CloseButton = tw.theme({
  extend: DialogTheme.CloseButton,
  variants: {
    icon: {
      true: [
        '!bg-transparent',
        'focus:bg-transparent',
        '[&>svg]:fill-logga-700',
        'border-none',
        'focus:ring-logga-700',
      ],
    },
  },
});

const DialogIcon = tw.theme({
  extend: DialogTheme.DialogIcon,
  slots: {
    base: ['*:fill-logga-600'],
  },
});

const Dialog = tw.theme({
  extend: DialogTheme,
  slots: {
    base: ['backdrop:bg-black/60', 'bg-gray-50'],
  },
});

export default Object.assign(Dialog, {
  DialogIcon,
  CloseIcon: DialogTheme.CloseIcon,
  Button: DialogTheme.Button,
  CloseButton,
});
